import React from "react";
import NewBillDesigner from "./NewBillDesigner";

function NewBillPrintTab() {
  return <NewBillDesigner />;
}

export default NewBillPrintTab;
